(function () {
  // Same price in every size (Oct 13 2026, J: "it's a selling point"). Brands that charge nothing extra for
  // 2XL and 3XL (AS Colour and Recover today) say so: the style page's price caption reads "S–3XL" instead of
  // "S–XL" and a line under the price spells it out; the catalog card's size line reads "Same price S–3XL"
  // (on phones, where the theme hides that line, the words go under the card's price caption instead).
  // Data-driven: a style qualifies when it carries 2XL or 3XL and its up[] has no upcharge, so a price change in
  // the catalog data turns the wording on or off by itself. Youth styles never qualify (no 2XL or 3XL).
  var booted = false, mo;
  function $(id) { return document.getElementById(id); }
  function st(id) { return typeof window.styleById === "function" ? window.styleById(id) : null; }
  function flat(s) {
    if (!s || !Array.isArray(s.sz)) return false;
    var u = s.up || [], big = s.sz.indexOf("2XL") >= 0 || s.sz.indexOf("3XL") >= 0;
    return big && !u[0] && !u[1];
  }
  function run(s) { var a = s.sz.filter(function (z) { return z !== "XS"; }); return a[0] + "–" + a[a.length - 1]; }
  function bigs(s) { return ["2XL", "3XL"].filter(function (z) { return s.sz.indexOf(z) >= 0; }); }
  function noteHTML(s) {
    var b = bigs(s);
    return "<strong>Same price in every size.</strong> " + (b.length === 2 ? "2XL and 3XL cost" : b[0] + " costs") + " the same as S–XL.";
  }
  function css() {
    if ($("sameSzCss")) return;
    var e = document.createElement("style"); e.id = "sameSzCss";
    e.textContent = ".sameSz{order:1;margin:4px 0 16px;font-size:14px;line-height:1.5;color:var(--ink-2,#4b4b4b)}.sameSz strong{color:var(--ink,#111);font-weight:700}#rvaCat .cSame{display:none}@media (max-width:749px){.sameSz{margin:2px 0 14px;font-size:13.5px}}@media (max-width:430px){#rvaCat .cSame{display:inline}}";
    document.head.appendChild(e);
  }
  function drop(id) { var e = $(id); if (e && e.parentNode) e.parentNode.removeChild(e); }
  function panel() {
    var S = window.S, s = S && S.open && st(S.open), p = $("panel");
    if (!p || !s || !flat(s)) { drop("sameSzNote"); return; }
    var r = run(s);
    Array.prototype.forEach.call(p.querySelectorAll(".pPriceSub"), function (el) {
      if (el.innerHTML.indexOf("S–XL") >= 0) el.innerHTML = el.innerHTML.replace("S–XL", r);
    });
    var box = p.querySelector(".pPriceBox");
    if (!box || !box.parentNode) return;
    var n = $("sameSzNote");
    if (!n) { n = document.createElement("p"); n.id = "sameSzNote"; n.className = "sameSz"; n.setAttribute("role", "note"); }
    var h = noteHTML(s);
    if (n.innerHTML !== h) n.innerHTML = h;
    // .pMeta is a flex column ordered by CSS (price box and the Sizes line are order 1); the note takes order 1 too
    // and sits right after the Sizes line when the style section has drawn it, else right after the price box.
    var anchor = box, nx = box.nextElementSibling;
    if (nx && nx.classList && nx.classList.contains("ssInfo")) anchor = nx;
    if (n.previousElementSibling !== anchor) anchor.parentNode.insertBefore(n, anchor.nextSibling);
  }
  function cards() {
    Array.prototype.forEach.call(document.querySelectorAll("#grid .card[data-id]"), function (a) {
      var s = st(a.getAttribute("data-id"));
      if (!flat(s)) return;
      var r = run(s), el = a.querySelector(".cSize"), per = a.querySelector(".cPer");
      if (el && el.innerHTML.indexOf("Same price") < 0 && el.innerHTML.indexOf(r) >= 0) el.innerHTML = el.innerHTML.replace(r, "Same price " + r);
      // phones hide .cSize (theme CSS under 430px), so the same words ride under the price caption there
      if (per && !per.querySelector(".cSame")) per.insertAdjacentHTML("beforeend", '<span class="cSame"><br>Same price ' + r + "</span>");
    });
  }
  function hook(name, fn) {
    var f = window[name];
    if (typeof f !== "function" || f.rvaSameSz) return;
    var g = function () { var r = f.apply(this, arguments); try { fn.apply(this, arguments); } catch (e) {} return r; };
    g.rvaSameSz = 1; window[name] = g;
  }
  function boot() {
    if (booted) return true;
    if (typeof window.styleById !== "function" || typeof window.render !== "function" || typeof window.drawPanel !== "function") return false;
    booted = true;
    css();
    hook("render", cards);
    hook("drawPanel", function () { panel(); setTimeout(panel, 80); });
    var grid = $("grid");
    if (grid && window.MutationObserver) {
      var t = 0, g = new MutationObserver(function () { clearTimeout(t); t = setTimeout(cards, 30); });
      g.observe(grid, { childList: true });
    }
    cards(); panel();
    return true;
  }
  if (!boot()) {
    var root = $("rvaCat") || document.body;
    if (window.MutationObserver) { mo = new MutationObserver(function () { if (boot()) mo.disconnect(); }); mo.observe(root, { childList: true, subtree: true }); }
    document.addEventListener("DOMContentLoaded", function () { if (!boot()) window.addEventListener("load", boot); });
  }
})();
